import {Component, inject, OnInit} from '@angular/core';
import {environment} from '../environments/environment';
import {AnalyticsService} from './core/services/analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  readonly #analyticsService = inject(AnalyticsService);

  ngOnInit(): void {
    this.loadGoogleMaps();
    this.#analyticsService.init();
  }

  private loadGoogleMaps(): void {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?libraries=places&key=${environment.googleMapsApiKey}`;
    document.head.appendChild(script);
  }
}
